import { render, staticRenderFns } from "./modalListadoArticulos.vue?vue&type=template&id=ff45a5be&"
import script from "./modalListadoArticulos.vue?vue&type=script&lang=js&"
export * from "./modalListadoArticulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports